export default "__VITE_ASSET__a64727b5__"